import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from '@jabilcore/microsoft-adal-angular6';
import { AppComponent } from './app.component';
import { ContentComponent } from './main/content/content.component';
import { Error404Component } from './main/errorsPages/404/error-404.component';
import { MainComponent } from './main/main.component';
import { CognitoGuard } from './core/cognito-guard/cognito-guard';
import { CanActivateAuthGuard } from './auth/can-activate-auth-guard';


const routesQuetza: Routes = [
  { path: 'main', loadChildren: () => import('./main/content/sections/sections.module').then( (mod) => mod.SectionsModule,),
		//canActivate: [CognitoGuard],
	},
	{
		path: 'login', loadChildren: () => import('./main/content/sections/sections.module').then( (mod) => mod.SectionsModule,), canActivate: [CognitoGuard],},
	{ path: '', redirectTo: 'main/home', pathMatch: 'full',
		//,canActivate: [AuthenticationGuard]
	},
	{
		path: '**',
		component: Error404Component,
	},
];

const routesCognito: Routes = [
  { path: 'main', canActivate: [CognitoGuard], loadChildren: () => import('./main/content/sections/sections.module').then(mod => mod.SectionsModule) },
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  { path: '**', component: Error404Component }
];

const routesLocal: Routes = [
  { path: 'main', component: MainComponent, loadChildren: () => import('./main/content/sections/sections.module').then(mod => mod.SectionsModule), canActivate: [CanActivateAuthGuard] },
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  { path: 'auth', loadChildren: () => import('./auth/login.module').then(mod => mod.LoginModule) },
  { path: '**', component: Error404Component }
];

const routes: Routes = window["loginType"] == 1 ? routesQuetza : window["loginType"] == 2 ? routesCognito : routesLocal;

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
